// The words @foodamigos/ui's chat parts show or read out, which the package has in English only (their `labels`
// props, 0.3.0); usePlatformAgentLabels hands them to each part.
export default {
  composer: {
    send: 'Verzenden',
    stop: 'Stoppen',
    attach: 'Bestanden toevoegen',
    add: 'Toevoegen',
    upload_files: 'Bestanden uploaden',
  },
  attachment: {
    uploading: 'Uploaden {{percent}}%',
    uploading_file: '{{name}} uploaden',
    retry: 'Opnieuw proberen',
    remove: '{{name}} verwijderen',
    cancel: 'Uploaden van {{name}} annuleren',
  },
  // What screen readers hear for each step's state, and the collapsed list's line ("4 steps · 1 failed and was retried").
  steps: {
    pending: 'Wachten',
    running: 'Bezig',
    done: 'Klaar',
    failed: 'Mislukt',
    denied: 'Geweigerd',
    background: 'Achtergrond',
    summary_one: '{{count}} stap',
    summary_other: '{{count}} stappen',
    failed_count_one: '{{count}} mislukt',
    failed_count_other: '{{count}} mislukt',
    retried_one: '{{count}} mislukt en opnieuw geprobeerd',
    retried_other: '{{count}} mislukt en opnieuw geprobeerd',
  },
  question: {
    suggested: 'Voorgesteld',
    withdrawn: 'Niet meer nodig',
  },
  thread: {
    live_on: 'Live op {{domain}}',
    unread_one: '{{count}} nieuw',
    unread_other: '{{count}} nieuw',
    working: 'Bezig ermee',
  },
  // What screen readers hear for each row of a list that needs a look.
  checklist: {
    done: 'Klaar',
    running: 'Bezig',
    waiting: 'Aandacht nodig',
    failed: 'Mislukt',
    pending: 'Nog niet',
    skipped: 'Overgeslagen',
  },
  lightbox: {
    enlarge: 'Vergroten: {{label}}',
    close: 'Sluiten',
  },
};
